import { API_BASE } from '../config'

// Auth-gated photo URL. /uploads is PHI, and the server identifies the viewer
// from an HttpOnly cookie the browser attaches on its own — so this URL carries
// no credential at all, only a filename.
//
// It used to append the session token as ?t=, because <img> cannot send an
// Authorization header. That made every image link a bearer credential: copied
// out of the address bar it was the viewer's whole session, wherever it landed.
//
// Accepts a bare filename ("123-face.jpg") or a server path ("/uploads/x.jpg").
export function photoUrl(filename) {
  if (!filename) return ''
  const f = String(filename).replace(/^\/?uploads\//, '')
  return `${API_BASE}/uploads/${f}`
}
